<template>
  <content-placeholders :rounded="true" :animated="false">
    <ModalPicture></ModalPicture>
    <div class="card p-4">
      <div class="card-body">
        <div class="invoice-title">
          <h4 class="float-end" style="font-size: 16px">
            <strong>
              Order ID :
              <span class="text-dark">
                {{ invoice.invoice.slice(-6) }}
              </span>
            </strong>
            <i
              class="fas fa-receipt text-primary pull-right"
              style="font-size: 20px"
            ></i>
          </h4>

          <div class="mb-4">
            <!-- <img src="assets/images/logo-dark.png" alt="logo" height="20">  -->
          </div>
        </div>
        <hr />
        <div class="row" style="font-size: 14px">
          <div class="col-sm-6">
            <div v-if="parseInt(orderStatusId) >= 2">
              <strong>
                No Pesanan : <br />
                <strong
                  >SP-{{ invoice.invoice.substring(0, 6)
                  }}{{ invoice.invoice.slice(-6) }}</strong
                >
              </strong>
              <br /><br />
            </div>

            <strong>Metode Pembayaran :</strong><br />
            {{ paymentMethod.bank }}
            <br />
            Nomor VA :
            {{ paymentMethod.accountNumber }} <br /><br />
            <strong>Toko :</strong><br />
            {{ mall.name }}
            <br />
            {{ mall.location }}
            <br /><br />
            <strong>Ekspedisi :</strong><br />
            {{ shipping.name }}
            <br />
            <strong>Resi :</strong>
            <span v-if="parseInt(orderStatusId) >= 3">{{ shipping.awb }}</span
            ><br />
          </div>
          <div class="col-sm-6 text-sm-end">
            <address class="mt-2 mt-sm-0">
              <strong>Sekolah :</strong><br />
              {{ school.name }}
              <br /><br />
              <strong>PIC Sekolah :</strong><br />
              {{ school.pic }}
              <br /><br />
              <strong>No Telp :</strong><br />

              {{ school.phoneNumber }}
              <br /><br />
              <strong>Alamat :</strong><br />
              {{ shipping.address }}
              <br /><br />
              <strong>Zona : </strong>

              {{ shipping.zone }}<br />
            </address>
          </div>
        </div>
        <div class="py-2 mt-3">
          <h4 class="font-weight-bold text-muted" style="font-size: 15px">
            Order summary <br />
          </h4>
        </div>
        <div class="table-responsive">
          <table class="table text-center" width="100%">
            <thead>
              <tr class="table-condensed">
                <th v-for="(col, index) in orderSummaryCol" :key="index">
                  {{ col }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(os, index) in orderSummary" :key="index">
                <td>{{ index + 1 }}</td>
                <td class="text-center">
                  <div class="zoom-gallery">
                    <a :href="os.image" :title="os.name">
                      <img :src="os.image" width="100px" height="auto" />
                    </a>
                  </div>
                  <!-- <div class="img-container">
                    <a  class="image-popup-no-margins" :href="os.image">
                      <img class="img-fluid" width="80px" :src="os.image" alt="" />
                    </a>
                  </div> -->
                </td>
                <td class="text-center">{{ os.name }}</td>
                <td class="text-center removeContent">
                  {{ os.priceCurrencyFormat }}
                </td>
                <td class="text-center">{{ os.qty }}</td>
                <td class="text-center">
                  {{ os.totalPriceCurrencyFormat }}
                </td>
              </tr>
              <tr v-if="orderSummary.length === 0">
                <td></td>
                <td class="text-center">
                  <div class="img-container">
                    <img
                      class="img-fluid"
                      width="80px"
                      src="http://placehold.jp/12px/d4d4d4/636363/150x150.png?text=No%20Image"
                      alt=""
                    />
                  </div>
                </td>
                <td class="text-center">-</td>
                <td class="text-center removeContent">-</td>
                <td class="text-center">-</td>
                <td class="text-center">-</td>
              </tr>
              <tr
                v-for="(desc, index) in descriptionTotal"
                :key="index + orderSummaryCol.length"
              >
                <td :colspan="orderSummaryCol.length - 1" class="text-right">
                  <span class="text-right font-weight-bold">{{ desc[0] }}</span>
                </td>
                <td :colspan="orderSummaryCol.length">
                  <span class="text-right">{{ desc[1] }}</span>
                </td>
              </tr>
            </tbody>
          </table>
          <div data-v-6b1a6342="" class="py-2 mt-3">
            <h4
              data-v-6b1a6342=""
              class="font-weight-bold text-muted"
              style="font-size: 15px;"
            >
              *Perhitungan ini adalah simulasi. Besaran dana disalurkan dapat
              berkurang apabila terdapat pemotongan biaya administrasi layanan
              dari mitra (jika pada halaman detail transaksi penyedia terdapat
              rincian harga dana diterima)
            </h4>
          </div>
        </div>
      </div>
    </div>
  </content-placeholders>
</template>

<script>
import ModalPicture from "../modal/modalPicture.vue";
// import $ from "jquery";
export default {
  components: {
    ModalPicture,
  },
  props: {
    invoice: {},
    paymentMethod: {},
    mall: {},
    shipping: {},
    school: {},
    orderSummary: {},
    orderSummaryCol: {},
    descriptionTotal: {},
    orderStatusId: String,
  },

  methods: {
    // openModal(image) {
    //   var bg = image;
    //   // eslint-disable-next-line
    //   bg = bg.replace("url(", "").replace(")", "").replace(/\"/gi, "");
    //   $("#imagePopup .modal-body").html(
    //     `<img src="${bg}"` +
    //     " width='50%' height='50%' class='clicked img-fluid rounded mx-auto d-block'>"
    //   );
    //   $("#imagePopup").modal("show");
    // },
  },
};
</script>

<style scoped></style>
